import { Typography } from "antd";
import { type ReactNode, useCallback } from "react";
import { Helmet } from "react-helmet-async";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import "./Page.scss";
const { Title } = Typography;

const TitleWrapper = styled.div`
  display: flex;

  .ant-typography {
    @media only screen and (max-width: 576px) {
      font-size: 24px;
    }
  }

  h1,
  span {
    margin-top: auto;
    margin-bottom: auto;
  }

  span {
    display: flex;
    margin-left: auto;

    i {
      margin-top: auto;
      margin-bottom: auto;
    }
  }
`;

interface Props {
  children: ReactNode;
  title?: ReactNode;
  subtitle?: ReactNode;
  showBackButton?: boolean;
  backButtonTextKey?: string;
  onBack?: () => void;
  useDefaultTitle?: boolean;
  tabTitle?: string;
  constrained?: boolean;
}
const Page = ({
  children,
  title,
  subtitle,
  showBackButton = true,
  backButtonTextKey = "goback",
  onBack,
  tabTitle = "Competition Management",
}: Props) => {
  const { formatMessage } = useIntl();
  const navigate = useNavigate();
  const handleBack = useCallback(() => {
    if (onBack) {
      onBack();
    } else {
      navigate(-1);
    }
  }, [onBack, navigate]);
  return (
    <div data-testid="page-wrapper">
      {showBackButton && (
        <div className="back-button-wrapper">
          <i className="fas fa-arrow-left" />
          <div onClick={handleBack}>
            {formatMessage({
              id: backButtonTextKey,
            })}
          </div>
        </div>
        )}
      <div>
        <div className={"mb-1"}>
          <Helmet>
            <title>{tabTitle}</title>
          </Helmet>
        </div>
        <TitleWrapper>
          {title && (
            <Title data-testid="page-title" level={2}>
              {title}
            </Title>
          )}
        </TitleWrapper>
        {subtitle && <SubTitle data-testid="page-subtitle">{subtitle}</SubTitle>}
        {children}
      </div>
    </div>
  );
};

const SubTitle = styled.div`
  margin-bottom: 18px;
`;

export default Page;
